import {
  BoltIcon,
  ChevronRightIcon,
  BuildingOfficeIcon,
  ChevronLeftIcon,
  BookmarkIcon,
  ArrowLeftIcon,
  PlusSmallIcon,
  TrashIcon,
  CheckCircleIcon,
  ArrowDownOnSquareIcon,
  ArrowRightIcon,
  PencilSquareIcon,
  PencilIcon,
  MapIcon,
  BellIcon,
  Bars3Icon,
  ArrowRightOnRectangleIcon,
  DocumentTextIcon,
  RocketLaunchIcon,
  InformationCircleIcon,
  BriefcaseIcon,
  PlusIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  ArrowTopRightOnSquareIcon,
  ClipboardIcon,
  PlusCircleIcon,
  ClipboardDocumentIcon,
  ChevronUpDownIcon,
  FaceFrownIcon,
  ChatBubbleLeftRightIcon,
  PrinterIcon,
  Cog6ToothIcon,
  LockClosedIcon,
} from '@heroicons/react/24/outline';
import {
  BookmarkIcon as BookmarkSolidIcon,
  XMarkIcon as XMarkSolidIcon,
  AdjustmentsHorizontalIcon,
  ChartBarIcon,
  EyeIcon,
  QrCodeIcon,
  PencilSquareIcon as PencilSquareSolidIcon,
  ArrowDownTrayIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ArrowPathIcon,
  EllipsisHorizontalIcon,
  EyeSlashIcon,
  ArrowUpTrayIcon,
} from '@heroicons/react/24/solid';
// --> types
import {
  ResetIcon,
  getAssetSrc,
  HeadphoneIcon,
  ApplyMoreFiltersIcon,
  BellAlertIcon,
  UmbrellaIcon,
  LockOpenIcon,
  ShareIcon,
  ReceptionIcon,
  SalaIcon,
  CucinaIcon,
  BarIcon,
  PencilModifyIcon,
  UploadIcon,
} from '@restworld/utils-common';
import { Spinner } from '../spinner';

export const buttonIconMap = {
  BoltIcon: <BoltIcon className="h-4 w-4" />,
  ShareIcon: <ShareIcon size={16} />,
  ShareSmallIcon: <ShareIcon size={20} stroke="black" />,
  ShareWhiteIcon: <ShareIcon size={24} stroke="white" />,
  ChevronRightIcon: <ChevronRightIcon className="w-5 h-5" />,
  ChevronLeftIcon: <ChevronLeftIcon className="w-5 h-5" />,
  OfficeBuildingIcon: <img src={getAssetSrc('/utils-assets/office-building-icon.svg')} className="h-5 w-5" alt="" />,
  BuildingOfficePurpleIcon: <BuildingOfficeIcon className="h-5 text-primary-800" />,
  BuildingOfficeWhiteIcon: <BuildingOfficeIcon className="h-5 text-white" />,
  BookmarkIcon: <BookmarkIcon className="h-6 w-6" />,
  BookmarkSolidIcon: <BookmarkSolidIcon className="h-6 w-6 text-primary-800" />,
  ArrowLeftIcon: <ArrowLeftIcon className="h-6 w-6 font-medium text-black" />,
  ArrowRightIcon: <ArrowRightIcon className="h-5 w-5 font-medium" />,
  ArrowRightPurpleIcon: <ArrowRightIcon className="h-5 w-5 font-medium text-primary-700" />,
  PlusSmallIcon: <PlusSmallIcon className="h-6 w-6 text-black" />,
  PlusPurpleSmallIcon: <PlusSmallIcon className="w-5 h-5 text-primary-700" />,
  WhiteTrashIcon: <TrashIcon className="h-5 w-5 text-white" />,
  RedTrashIcon: <TrashIcon className="h-5 w-5 text-red-600" />,
  RedTrashIconSmall: <TrashIcon className="h-4 w-4 text-red-600" />,
  GrayTrashIcon: <TrashIcon className="h-5 w-5 text-gray-400 " />,
  PrimaryTrashIcon: <TrashIcon className="h-5 w-5 text-primary-700 " />,
  XMarkIcon: <XMarkSolidIcon className="h-5 w-5 text-primary-800" />,
  XMarkIconWhite: <XMarkSolidIcon className="h-5 w-5 text-white" />,
  XMarkIconBlack: <XMarkSolidIcon className="h-6 w-6 text-black" />,
  SuccessIcon: <CheckCircleIcon className="h-5 w-5 text-green-500" />,
  CurleTippedPencilIcon: (
    <img src={getAssetSrc('/utils-assets/pencil-edit-skip-icon.svg')} className="h-5 w-5" alt="" />
  ),
  EditPencilBlackIcon: <PencilIcon className="h-4 w-4 text-black" />,
  EditPencilWhiteIcon: <PencilIcon className="h-5 w-5 text-white" />,
  PencilModifyIcon: <PencilModifyIcon />,
  PencilSquareIcon: <PencilSquareIcon className="h-6 w-6 text-primary-800" />,
  ArrowDownOnSquareIcon: <ArrowDownOnSquareIcon className="h-5 w-5 text-gray-900" />,
  ResetIcon: <ResetIcon />,
  HeadphoneIcon: <HeadphoneIcon />,
  ApplyMoreFilterWhiteIcon: <ApplyMoreFiltersIcon stroke="#fff" />,
  ApplyMoreFilterBlackIcon: <ApplyMoreFiltersIcon stroke="black" />,
  ApplyMoreFilterGrayIcon: <ApplyMoreFiltersIcon stroke="#9ca3af" />,
  BellAlertIcon: <BellAlertIcon />,
  BellIconPurple: <BellIcon className="h-6 w-6 text-primary-900" />,
  BellIconWhite: <BellIcon className="h-6 w-6 text-white" />,
  BellIconGray: <BellIcon className="h-6 w-6 text-gray" />,
  MapIcon: <MapIcon className="h-6 w-6 text-white" />,
  UmbrellaIcon: <UmbrellaIcon />,
  LockOpenIcon: <LockOpenIcon />,
  LockClosedIcon: <LockClosedIcon />,
  BarsIconBlack: <Bars3Icon className="h-6 w-6 text-black" />,
  BarsIconWhite: <Bars3Icon className="h-6 w-6 text-white" />,
  ArrowRightOnRectangleBlackIcon: <ArrowRightOnRectangleIcon className="h-6 w-6 text-black" />,
  ArrowRightOnRectangleRedIcon: <ArrowRightOnRectangleIcon className="h-6 w-6 text-red" />,
  DocumentTextIcon: <DocumentTextIcon className="h-6 w-6 text-gray-900" />,
  RocketLaunchPurpleIcon: <RocketLaunchIcon className="h-6 w-6 text-primary-900" />,
  ReceptionIcon: <ReceptionIcon />,
  ReceptionIconActive: <ReceptionIcon {...{ stroke: '#693EB5' }} />,
  SalaIcon: <SalaIcon />,
  SalaIconActive: <SalaIcon {...{ stroke: '#693EB5' }} />,
  CucinaIcon: <CucinaIcon />,
  CucinaIconActive: <CucinaIcon {...{ stroke: '#693EB5' }} />,
  BarIcon: <BarIcon />,
  BarIconActive: <BarIcon {...{ stroke: '#693EB5' }} />,
  InformationCircleIcon: <InformationCircleIcon className="h-5 w-5 text-black" />,
  InformationCircleWhiteIcon: <InformationCircleIcon className="h-5 w-5 min-w-[20px] text-white" />,
  BriefcaseIcon: <BriefcaseIcon className="h-5 w-5 text-black" />,
  BriefcaseWhiteIcon: <BriefcaseIcon className="h-5 w-5 text-white" />,
  RocketLaunchGrayIcon: <RocketLaunchIcon className="h-6 w-6 text-gray-500" />,
  UploadIcon: <UploadIcon />,
  ChevronUpBlack: <ChevronUpIcon className="h-5 w-5 text-black" />,
  ChevronDownBlack: <ChevronDownIcon className="h-5 w-5 text-black" />,
  ArrowTopRightOnSquarePurpleIcon: <ArrowTopRightOnSquareIcon className="h-5 w-5 text-primary-900" />,
  ArrowTopRightOnSquareBlackIcon: <ArrowTopRightOnSquareIcon className="h-5 w-5 text-black" />,
  ClipboardIcon: <ClipboardIcon className="h-5 w-5" />,
  LoadingIcon: <Spinner color="primary" size="xs" />,
  PlusCircleIcon: <PlusCircleIcon className="h-5 w-5 text-primary-800" />,
  AdjustmentsHorizontalIcon: <AdjustmentsHorizontalIcon className="h-5 w-5 text-black" />,
  ChartBarIcon: <ChartBarIcon className="h-4 w-4 text-neutral-700" />,
  EyeIcon: <EyeIcon className="h-4 w-4" />,
  QrCodeIcon: <QrCodeIcon className="h-5 w-5" />,
  ClipboardDocumentIcon: <ClipboardDocumentIcon className="h-5 w-5" />,
  PencilSquareSolidIcon: <PencilSquareSolidIcon className="h-4 w-4" />,
  ArrowDownTrayIcon: <ArrowDownTrayIcon className="h-5 w-5" />,
  ChevronUpDownIcon: <ChevronUpDownIcon className="h-5 w-5 text-purple-500" />,
  ChatBubbleOvalLeftEllipsisIcon: <ChatBubbleOvalLeftEllipsisIcon className="h-5 w-5 text-purple-500" />,
  ArrowPathIcon: <ArrowPathIcon className="h-5 w-5 text-gray-500" />,
  EllipsisHorizontalIcon: <EllipsisHorizontalIcon className="h-6 w-6" />,
  PlusIcon: <PlusIcon className="h-4 w-4" />,
  ChevronDownIcon: <ChevronDownIcon className="h-4 w-4" />,
  ChevronUpIcon: <ChevronUpIcon className="h-4 w-4" />,
  FaceFrownIcon: <FaceFrownIcon className="h-5 w-5" />,
  ChatBubbleLeftRightIcon: <ChatBubbleLeftRightIcon className="h-5 w-5" />,
  EyeSlashIcon: <EyeSlashIcon className="h-5 w-5" />,
  EyeIconAlt: <EyeIcon className="h-5 w-5" />,
  ArrowUpTrayIcon: <ArrowUpTrayIcon className="h-5 w-5" />,
  PrinterIcon: <PrinterIcon className="h-5 w-5" />,
  Cog6ToothIcon: <Cog6ToothIcon className="h-5 w-5" />,
};
export const variantMap = {
  ghost: 'text-primary-900 bg-transparent border border-transparent focus:ring-primary-300 p-2',
  normal: 'text-primary-900 bg-secondary border-secondary hover:bg-secondary-800 border min-h-[3rem]',
  custom: 'bg-primary-50 text-gray-900',
  primary: 'bg-primary-800 text-white focus:ring-primary-300 whitespace-nowrap min-h-[3rem]',
  borderless: 'text-black',
  'primary-outline':
    'bg-white text-primary-900 border border-primary hover:bg-primary hover:text-white focus:ring-primary-300',
  danger: 'bg-white hover:bg-red-100 focus:ring-red-300',
  dark: 'bg-black text-white focus:ring-0',
  'gray-outline': 'border border-gray-300 focus:ring-gray-300 text-gray-600 whitespace-nowrap',
  'black-outline': 'border border-black focus:ring-black/25 bg-white',
  transparent: 'bg-transparent text-primary-700 border-none focus:ring-primary-50',
  'secondary-outline':
    'bg-white text-black border border-secondary-900 hover:bg-secondary-50 focus:ring-secondary-900 whitespace-nowrap',
  'black-text': 'text-black focus:ring-primary-300',
  'danger-ghost': 'text-red-600  bg-white text-left p-0 focus:ring-0',
  'danger-with-bg': 'bg-red-600 text-white focus:ring-red-300',
  'primary-light': 'bg-primary-50 !text-primary-800 border border-primary-800 focus:ring-primary-300 whitespace-nowrap',
  'gray-light': 'border border-gray-400 focus:ring-gray-300 text-gray-500 whitespace-nowrap',
  'white-ghost': 'text-black bg-transparent border-none focus:ring-white',
  'gray-50': 'bg-gray-50 text-black focus:ring-gray-300',
  'primary-small':
    'lg:text-sm  text-sm lg:leading-5.25 leading-5.25 font-normal bg-white py-2 px-3 border border-primary-700 text-primary-700 focus:ring-0 focus:bg-white focus:text-primary-700',
};
export const fontColorMap = {
  primary: 'text-primary-900',
  secondary: 'text-secondary-900',
  black: 'text-black',
  white: 'text-white',
  gray: 'text-gray-600',
  red: 'text-red-500',
  'neutral-700': 'text-neutral-700',
  'purple-500': 'text-purple-500',
};

export const fontWeightMap = {
  normal: 'font-normal',
  medium: 'font-medium',
  bold: 'font-bold',
  semibold: 'font-semibold',
  extrabold: 'font-extrabold',
};
